import requests from "./api/api";

const CargoService = {

   
    getAllCargo:(body)=>requests.get('/cargo/v1/get-all-cargo-user-web',body),
    getAllMyCargo:(body)=>requests.get('/cargo/v1/get-cargo-by-user',body),
    deleteMyCargo:(body)=>requests.delete('/cargo/v1/delete-user-cargo',body),
    editMyCargo:(body)=>requests.put('/cargo/v1/update-cargo',body),
    getDriverList:(body)=>requests.get('/cargo/v1/get-drivers-accepted-cargo',body),
    acceptDriver:(body)=>requests.patch('/cargo/v1/accepted-finalDriver-by-user',body),
    


    getAllCargoById:(id)=>requests.get(`/cargo/v1/get-cargo-user/${id}`),
    getAllState:(body)=>requests.get('/state/v1/get-all-state-user',body),
    getAllCountry:(body)=>requests.get('/state/v1/get-all-country-user',body),

    

    getAllCity:(body)=>requests.get('/state/v1/get-all-city-user',body),
    getAllCarType:(body)=>requests.get('/car/v1/get-all-car-user',body),

    getAllProductType:(body)=>requests.get('/cargo-product/v1/get-all-cargo-product-user',body),
    createCargo : (body)=>requests.post(`/cargo/v1/create-cargo-user`,body),

    likeCargo : (body)=>requests.post(`/user/v1/add-cargo`,body),
    disLikeCargo : (body)=>requests.post(`/user/v1/remove-cargo`,body),

    report: (body)=>requests.post(`/report/v1/create-report-user`,body),
    getAllFavorites:(body)=>requests.get('/user/v1/get-favorite-cargos-list-by-user',body),
    
    sendTicket:(body)=>requests.post(`/ticket/v1/add-ticket-user`,body),
    getTicket:(body)=>requests.get(`/ticket/v1/get-my-ticket-list-user`,body),
    updateImage:(body)=>requests.patch(`/user/v1/update-image`,body),
   
};

export default CargoService;